import { Box } from 'grommet';
import React from 'react'

const MainCanvas = (props: any) => {

  return (
    <Box
      margin={{ top: "30px" }}
      pad="10px"
      background="rgb(0,0,0,0.3)"
      border={{ color: "black" }}
      alignSelf="center"
      height="full"
      width="95%"
      style={{maxWidth: "800px"}}
      {...props}
    >
    </Box>
  )
}


export default MainCanvas;
